import * as React from 'react'

import styled from '@emotion/styled'

import { ArcadeButtonProps } from '../..'
import ArcadeButton from '../Button/ArcadeButton'

interface LinkProps {
  'aria-label': string
  href: string
  target?: HTMLAnchorElement['target']
  rel?: HTMLAnchorElement['rel']
}
type ArcadeButtonLinkProps = LinkProps & Omit<ArcadeButtonProps, 'as'>

const StyledButton = styled(ArcadeButton)<LinkProps>`
  text-decoration: none;
`

const ArcadeButtonLink: React.FC<ArcadeButtonLinkProps> = props => <StyledButton {...props} as="a" />

export default ArcadeButtonLink
